/**
 * @deprecated use downloadCSVNew instead
 */
export const downloadCsv = (csvContent: any, fileName: string) => {
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", "data:text/plain;charset=utf-8," + encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link); // Required for FF

  link.click();
};
